module.exports = __webpack_public_path__ + "static/media/180928-0018-28092018061803240phil21538140683230 - Copy.44adfda9.jpeg";